import { IRRIGATION_ACTIVITY_FLOW_METER_VALUE_TYPE_PREFIX } from '@semios/app-platform-values-helpers-and-types'
import { isPressureSensorValueType } from 'App/dashboards/_utils/isPressureSensorValueType'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'

export const hasWaterUsageAssets = (property: TProperty): boolean =>
  Object.keys(property.irrigationZoneEmitters ?? {}).length > 0 ||
  Object.values(property.points ?? {}).some((point) =>
    (point.valuesTimeseries ?? []).some(
      (valueType) =>
        valueType.includes(IRRIGATION_ACTIVITY_FLOW_METER_VALUE_TYPE_PREFIX) ||
        isPressureSensorValueType(valueType),
    ),
  )
